import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import TreePlantation from "../TreePlantation/treeplantation";
import './projects.css';
import WaterConservation from "../WaterConservation/waterconservation";
import OrganicFarming from "../OrganicFarming/organicFarming";
import WomenDevelopment from "../WomenDevelopment/women";
import WildVegetableFestival from "../WildVegetable/wildvegetable";

const Projects = () => {
  const location = useLocation();
  const sectionRefs = useRef({});

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      const section = sectionRefs.current[sectionId];
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className="projects-page">
      <h1>Making a Difference: Our Project</h1>
      <div
        id="tree-plantation"
        ref={(el) => (sectionRefs.current["tree-plantation"] = el)}
        className="projects-section"
      >
        <h2>Roots of Change: Tree Plantation Initiative</h2>
        <TreePlantation />
      </div>

      <div
        id="water-conservation"
        ref={(el) => (sectionRefs.current["water-conservation"] = el)}
        className="projects-section"
      >
        <h2>Water Conservation</h2>
        <WaterConservation />
      </div>

      <div
        id="organic-farming"
        ref={(el) => (sectionRefs.current["organic-farming"] = el)}
        className="projects-section"
      >
        <h2>Organic Farming</h2>
        <OrganicFarming />
      </div>

      <div
        id="women-development"
        ref={(el) => (sectionRefs.current["women-development"] = el)}
        className="projects-section"
      >
        <h2>MaheraCha Umhartha</h2>
        <WomenDevelopment />
      </div>

      <div
        id="wild-vegetable"
        ref={(el) => (sectionRefs.current["wild-vegetable"] = el)}
        className="projects-section"
      >
        <h2>RAN BHAJI MOHATSAV</h2>
        <WildVegetableFestival />
      </div>
    </div>
  );
};

export default Projects;
